import styled from '@emotion/styled'
export const StyleButtonWrapper = styled.div<any>`
  display: flex;
  ${(props) => props.styleButtonWrapper};
`
export const StyleButton = styled.button<any>`
  border-radius: ${(props) => props.radius || 6}px;
  border: ${(props) =>
    props?.outline
      ? `1px solid ${props.theme.colors[props.bg || 'primary']}`
      : '0px'};
  width: ${(props) => (props?.width ? `${props?.width}px` : 'auto')};
  height: ${(props) => (props?.height ? props?.height : 35)}px;
  background: ${(props) =>
    props?.outline ? 'transparent' : props.theme.colors[props.bg || 'primary']};
  padding: 0px 20px;
  font-size: 14px;
  font-weight: 300;
  display: flex;
  align-items: center;
  column-gap: 10px;
  justify-content: center;
  color: ${(props) =>
    props?.outline
      ? props.theme.colors[props.bg || 'primary']
      : props.theme.colors[props?.tc || 'white']};
  ${(props) => props.styleButton};
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 10px;
  cursor: pointer;
`
